import React from 'react';
import AsyncSelect from 'react-select/async';
import { useTranslation } from 'react-i18next';
import { customDropDownStyles } from './common/EditableDropdown';
// import { customDropDownStyles } from './common/Dropdown';

const AsyncDropdown = (props) => {
  const { t } = useTranslation();
  const {
    onChange,
    placeholder = 'Select an Option',
    isMultiSelect = false,
    disabled = false,
    value,
    width,
    backgroundColor = 'rgba(240, 240, 240, 1)',
    isInvalid,
    optionColor,
    fetchOptions,
    isLoading,
    cacheOptions = true,
  } = props;

  const loadOptions = async (inputValue, callback) => {
    try {
      const response = await fetchOptions(inputValue);
      callback(response);
    } catch (error) {
      console.error('Error loading options:', error);
      callback([]);
    }
  };

  return (
    <AsyncSelect
      isDisabled={disabled}
      onChange={onChange}
      cacheOptions={cacheOptions}
      loadOptions={loadOptions}
      value={value}
      defaultOptions
      placeholder={t(placeholder)}
      styles={{
        ...customDropDownStyles({ width, backgroundColor, isInvalid }),
        multiValue: (styles, { data }) => ({
          ...styles,
          backgroundColor: optionColor,
        }),
      }}
      isMulti={isMultiSelect}
      isLoading={isLoading}
    />
  );
};

export default AsyncDropdown;
